import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [errors, setErrors] = useState({
    username: '',
    password: ''
  });
  const [rememberDevice, setRememberDevice] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error for this field
    setErrors({
      ...errors,
      [name]: ''
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      username: '',
      password: ''
    };

    if (!formData.username.trim()) {
      newErrors.username = 'Name is required.';
      isValid = false;
    }

    if (!formData.password.trim()) {
      newErrors.password = 'Password is required.';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      // For demo purposes, using hardcoded credentials
      // Replace with actual API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      if (formData.username === 'admin' && formData.password === 'admin123') {
        const adminData = {
          id: '1',
          name: 'Ohhpro Official',
          email: 'ohhproofficial@gmail.com',
          role: 'Administrator',
          avatar: 'https://i.pravatar.cc/100?img=12'
        };

        localStorage.setItem('adminToken', 'demo-admin-token-12345');
        localStorage.setItem('adminData', JSON.stringify(adminData));

        if (rememberDevice) {
          localStorage.setItem('rememberDevice', 'true');
        }

        navigate('/blogmanagement');
      } else {
        setErrors({
          username: 'Invalid credentials.',
          password: 'Invalid credentials.'
        });
      }
    } catch (err) {
      setErrors({
        username: '',
        password: 'Login failed. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    alert('Google login integration coming soon!');
  };

  const handleFacebookLogin = () => {
    alert('Facebook login integration coming soon!');
  };

  return (
    <div className="admin-login-wrapper">
      {/* Left Side - Welcome Section */}
      <div className="admin-login-left">
        <div className="admin-login-content">
          <h1 className="admin-login-welcome-title">Welcome to<br />Dashboard</h1>
          <p className="admin-login-welcome-text">
            Dashboard helps developers to build organized and well coded<br />
            dashboards full of beautiful and rich modules.
          </p>
          <button className="admin-login-learn-more">Learn More</button>
        </div>
        
        {/* Decorative Shapes */}
        <div className="admin-login-shapes">
          <div className="admin-shape admin-shape-1"></div>
          <div className="admin-shape admin-shape-2"></div>
          <div className="admin-shape admin-shape-3"></div>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="admin-login-right">
        <div className="admin-login-form-container">
          {/* Logo */}
          <div className="admin-login-logo-wrapper">
            <svg className="admin-login-logo" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="8" height="32" rx="4" fill="#1D1C57" transform="translate(8 8)"/>
              <rect width="8" height="24" rx="4" fill="#1D1C57" transform="translate(20 16)"/>
              <rect width="8" height="40" rx="4" fill="#1D1C57" transform="translate(32 4)"/>
            </svg>
          </div>

          <h2 className="admin-login-form-title">Sign In</h2>
          <p className="admin-login-form-subtitle">Your Admin Dashboard</p>

          {/* Social Login Buttons */}
          <div className="admin-login-social-buttons">
            <button 
              type="button" 
              className="admin-login-social-btn"
              onClick={handleGoogleLogin}
            >
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Google
            </button>
            <button 
              type="button" 
              className="admin-login-social-btn"
              onClick={handleFacebookLogin}
            >
              <svg viewBox="0 0 24 24" width="20" height="20" fill="#1877F2">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              Facebook
            </button>
          </div>

          <div className="admin-login-divider">
            <span>or sign in with</span>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="admin-login-input-group">
              <label className="admin-login-label">Username</label>
              <input
                type="text"
                name="username"
                className={`admin-login-input ${errors.username ? 'admin-login-input-error' : ''}`}
                value={formData.username}
                onChange={handleChange}
                placeholder=""
              />
              {errors.username && (
                <span className="admin-login-error-text">{errors.username}</span>
              )}
            </div>

            <div className="admin-login-input-group">
              <label className="admin-login-label">Password</label>
              <input
                type="password"
                name="password"
                className={`admin-login-input ${errors.password ? 'admin-login-input-error' : ''}`}
                value={formData.password}
                onChange={handleChange}
                placeholder=""
              />
              {errors.password && (
                <span className="admin-login-error-text">{errors.password}</span>
              )}
            </div>

            <div className="admin-login-options">
              <label className="admin-login-checkbox-label">
                <input
                  type="checkbox"
                  checked={rememberDevice}
                  onChange={(e) => setRememberDevice(e.target.checked)}
                />
                <span>Remember this Device</span>
              </label>
            </div>

            <button 
              type="submit" 
              className="admin-login-submit-btn"
              disabled={loading}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          {/* <div className="admin-login-footer-text">
            New to MDash? <a href="#" className="admin-login-create-link">Create an account</a>
          </div> */}
        </div>
      </div>
      
    </div>
  );
};

export default AdminLogin;